export default __webpack_public_path__ + "static/media/prev-icon.7cc03c98.svg";